export default "__VITE_ASSET__CKeNMfwf__"